// extracted by mini-css-extract-plugin
export default {"table":"Map_table__LWnYH"};